import { render } from "./markettrends-tabheader.vue?vue&type=template&id=60d6c130"
import script from "./markettrends-tabheader.js?vue&type=script&lang=js"
export * from "./markettrends-tabheader.js?vue&type=script&lang=js"

import "./markettrends-tabheader.vue?vue&type=style&index=0&id=60d6c130&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__